
export const onedrive_info = 'Microsoft OneDrive is a cloud storage service included with the Microsoft 365 suite. It allows you to store, access, and share your work files securely from any device, with automatic syncing and backup across platforms.'

export const onedrive_md = `
# Microsoft OneDrive  
*Last updated on July 15, 2025*

## Overview

Microsoft OneDrive is a cloud storage service included with the Microsoft 365 suite. 
It allows you to store, access, and share your work files securely from any device, with automatic syncing and backup across platforms.
If you have a user account with us, you get 1TB of OneDrive storage to use.

Important Note: we recommend that you use OneDrive. 
In the event that your computer stops working, OneDrive will have your Desktop, Documents, and Pictures folders backed up so you won't have to worry as much about data loss.
In addition, OneDrive will automatically restore your backed up files to your new computer upon sign-in in the event that you need to upgrade your device. 

## Benefits
- **Anywhere Access**: Access your files from desktop, web, or mobile.
- **Automatic Saving & Backup**: Protects your documents by syncing them to the cloud in real time.
- **File Sharing**: Easily share files or folders with internal and external colleagues.
- **Collaboration**: Work on documents simultaneously with others using Microsoft 365 suite apps.
- **Secure Storage**: Encrypted and compliant with organizational security standards.

## Requirements
- A user account with us  
- A valid Microsoft 365 subscription  
- Internet access  

## Getting Started
- OneDrive is included as part of the [Microsoft 365](https://it.bockwaterheaters.com/#/services/m365) suite.
- Please launch the OneDrive app by searching for it in the start menu. Sign into it if you are prompted to.
- Confirm the location of your OneDrive folder.
- You can configure your settings and what folders get backed up by clicking on the blue OneDrive cloud icon in your system tray area.
- It will automatically integrate with your files and backup your Desktop, Pictures, and Documents.

For online access, go to [https://onedrive.office.com](https://onedrive.office.com), sign in, and you'll be taken to your files.

## Support
- Contact our [IT Help Desk](https://it.bockwaterheaters.com/#/help)


`